import { type Group } from "@1js/pl-types";
import {
  Avatar,
  Option,
  Tooltip,
  makeStyles,
} from "@fluentui/react-components";
import * as React from "react";

export type GroupOptionProps = {
  group: Group;
};

const useStyles = makeStyles({
  optionContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    overflow: "hidden",
  },
  optionName: {
    marginLeft: "6px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

export const GroupOption: React.FC<GroupOptionProps> = ({ group }) => {
  const image = group.AvatarUrl ? { src: group.AvatarUrl } : undefined;
  const styles = useStyles();
  return (
    <Option key={group.Id} text={group.DisplayName} value={group.Id}>
      <div className={styles.optionContainer}>
        <Avatar
          name={group.DisplayName}
          shape="square"
          image={image}
          color="colorful"
          size={20}
        />
        <Tooltip content={group.DisplayName} relationship={"label"}>
          <div className={styles.optionName} data-testid="team-option-text">
            {group.DisplayName}
          </div>
        </Tooltip>
      </div>
    </Option>
  );
};
